import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FaqPage from "../pages/faq/page";
import CoCreatorPage from "../pages/co-creator/page";
import PricingPage from "../pages/pricing/page";
import SingleUseFormPage from "@/pages/single-use/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/co-creator",
    element: <CoCreatorPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/single-use",
    element: <SingleUseFormPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
